import { render, staticRenderFns } from "./Notifier.vue?vue&type=template&id=2d019e01&scoped=true"
import script from "./Notifier.vue?vue&type=script&lang=js"
export * from "./Notifier.vue?vue&type=script&lang=js"
import style0 from "./Notifier.vue?vue&type=style&index=0&id=2d019e01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d019e01",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VRow})
